const INGREDIENT_KEYWORDS_TRANSFER_INITIAL_STATE = {
  isFinishedTransfering: false,
  keywordsToTransfer: [],
}

export default INGREDIENT_KEYWORDS_TRANSFER_INITIAL_STATE
